import React, {useMemo, useState} from 'react';
import {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, ButtonProps, FloatingPosition, Popover, Tooltip} from '@mantine/core';

type ConfirmButton = Omit<ButtonProps, 'type' | 'as'> & {
  onConfirm: () => void;
  loading?: boolean;
  text?: string;
  tooltip?: string;
  confirmPosition?: FloatingPosition;
  loadingText?: string;
  confirmText?: string;
  icon?: IconDefinition;
  confirmProps?: Omit<ButtonProps, 'type' | 'as' | 'link'>;
};

const EmptyWrapper: React.FC = (props) => <span {...props} />;

export const ConfirmButton: React.FC<ConfirmButton> = ({
  onConfirm,
  loading,
  text,
  icon,
  variant,
  confirmProps,
  tooltip = '',
  confirmPosition = 'right',
  loadingText = 'Loading...',
  confirmText = 'Are you sure?',
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onConfirmClick = () => {
    onConfirm();
    onClose();
  };

  const TooltipWrapper = tooltip ? Tooltip : EmptyWrapper;
  const tooltipProps = tooltip ? {label: tooltip} : ({} as any);

  const iconStyle = useMemo(() => ({marginRight: text ? 10 : 0}), [text]);

  return (
    <Popover
      opened={open}
      position={confirmPosition}
      withArrow
      shadow="md"
      onClose={onClose}
      closeOnEscape
    >
      <Popover.Target>
        <div>
          <TooltipWrapper {...tooltipProps}>
            <Button
              type="button"
              onClick={toggleOpen}
              disabled={loading}
              px={text ? 15 : 10}
              variant={variant}
              {...props}
            >
              {icon && (
                <FontAwesomeIcon
                  icon={icon}
                  style={iconStyle}
                />
              )}
              <>{loading ? loadingText : text}</>
            </Button>
          </TooltipWrapper>
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <Button
          type="button"
          color={props.color}
          onClick={onConfirmClick}
          disabled={loading}
          {...confirmProps}
        >
          {confirmText}
        </Button>
      </Popover.Dropdown>
    </Popover>
  );
};